import { render, staticRenderFns } from "./StreamBottomOverlay.vue?vue&type=template&id=1c3ca618&scoped=true&"
import script from "./StreamBottomOverlay.vue?vue&type=script&lang=js&"
export * from "./StreamBottomOverlay.vue?vue&type=script&lang=js&"
import style0 from "./StreamBottomOverlay.vue?vue&type=style&index=0&id=1c3ca618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ca618",
  null
  
)

export default component.exports